<template>
  <div id="essay-writing" class="select-module-page">
    <b-container fluid class="background module-page-shell">
      <b-row class="responsive-padding module-breadcrumb-row">
        <breadcrumb :items="items"></breadcrumb>
      </b-row>

      <section class="module-hero">
        <h1 class="module-page-title">{{ title }}</h1>
      </section>

      <section class="module-stage responsive-padding">
        <div class="module-stage__top">
          <a
            class="module-stage__template-link module-stage__template-link--disabled strip"
            aria-disabled="true"
            tabindex="-1"
          >
            ✍️ View Templates &amp; Examples 
            <span class="module-stage__template-arrow"> →</span>
          </a>
        </div>

        <div class="module-stage__grid">
          <article
            v-for="card in moduleCards"
            :key="card.id"
            class="module-section"
            @click="handleModuleStart(card.id)"
          >
            <h2 class="module-section__label">{{ card.sectionTitle }}</h2>

            <div class="module-card">
              <div class="module-card__icon-shell">
                <b-img
                  :src="require('../../assets/writing_feature/' + card.img)"
                  :alt="card.title"
                  class="module-card__icon"
                ></b-img>
              </div>

              <h3 class="module-card__title">{{ card.title }}</h3>
              <p v-if="card.time" class="module-card__time">{{ card.time }}</p>

              <ul class="module-card__points">
                <li v-for="point in card.points" :key="point">
                  {{ point }}
                </li>
              </ul>

              <div class="module-card__button">
                <purplebutton
                  :buttonprops="card.button"
                  class="module-card__button-control"
                ></purplebutton>
              </div>
            </div>
          </article>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import breadcrumb from "../../components/writing_feature/BreadCrumb.vue";
import purplebutton from "../../components/writing_feature/PurpleButton.vue";
import { onMounted } from "vue";
import { trackEvent } from "@/services/analyticsService";

export default {
  components: {
    breadcrumb,
    purplebutton
  },
  setup() {
    onMounted(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      trackEvent("writing_module_select_viewed");
    });

    const items = [
      {
        text: "Essay Writing: LEQ",
        active: "yes"
      }
    ];

    const moduleCards = [
      {
        id: "beginner",
        sectionTitle: "Practice Module",
        img: "ModuleIcon3.svg",
        title: "Essay Fundamentals",
        points: [
          "Section step by step guides",
          "Sample prompts",
          "No time restriction"
        ],
        button: {
          content: "Start",
          route: "002",
          params: { module: "Beginner" },
          disabled: false
        },
        time: "~30 min-1hr"
      },
      {
        id: "expert",
        sectionTitle: "Timed Module",
        img: "ModuleIcon2.svg",
        title: "Practice Writing",
        points: [
          "Explore each section in-depth",
          "Sample prompts",
          "Time restriction"
        ],
        button: {
          content: "Start",
          route: "002",
          params: { module: "Expert" },
          disabled: false
        },
        time: "~45 min-1hr"
      }
    ];

    const title = "Welcome to the Essay Writing for the LEQ";

    const handleModuleStart = (moduleId) => {
      trackEvent("module_selected", { module_id: moduleId });
    };

    return {
      items,
      title,
      moduleCards,
      handleModuleStart
    };
  }
};
</script>

<style scoped>
#essay-writing {
  min-height: 100vh;
  background: #f4f5f7;
  font-family: "Manrope", sans-serif;
}

.background {
  min-height: 100vh;
  background: #f4f5f7;
  padding: 1.25rem 1.5rem 3.5rem;
}

.module-page-shell {
  max-width: 1200px;
}

.module-breadcrumb-row {
  margin: 0 0 0.9rem;
}

.module-hero {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.module-page-title {
  margin: 0;
  color: #171717;
  text-align: center;
  font-size: clamp(1.8rem, 2.3vw, 2.35rem);
  font-weight: 800;
  line-height: 1.08;
}

.module-stage {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0.85rem 0.85rem 2.25rem;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 24px 48px rgba(17, 17, 17, 0.08);
}

.module-stage__top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.1rem;
}

.module-stage__template-link {
  color: #6a35c1;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-decoration: none;
  padding: 20px !important;
  padding-right: 50px !important;
}

.module-stage__template-link--disabled {
  color: #2b2d31;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.55;
  filter: grayscale(1);
  user-select: none;
}

.module-stage__template-arrow {
  margin-left: 0.35rem;
}

.module-stage__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(280px, 1fr));
  gap: 1.5rem;
  align-items: start;
}

.module-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.module-section__label {
  margin: 0 0 0.75rem;
  color: #222;
  text-align: center;
  font-size: 1.18rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.module-card {
  width: 100%;
  max-width: 420px;
  min-height: 372px;
  padding: 1.4rem 1.35rem 1.25rem;
  border-radius: 18px;
  background: linear-gradient(180deg, #f7f7f7 0%, #f4f4f4 100%);
  box-shadow: 0 12px 30px rgba(17, 17, 17, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.module-card__icon-shell {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.module-card__icon {
  width: 86px;
  max-width: 100%;
  height: auto;
  max-height: none;
}

.module-card__title {
  margin: 0;
  color: #2a2a2a;
  font-size: 1.32rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.module-card__time {
  margin: 0.2rem 0 0.85rem;
  color: #7b7b7b;
  font-size: 0.9rem;
}

.module-card__points {
  width: 100%;
  max-width: 250px;
  margin: 0 0 1.2rem;
  padding: 0;
  list-style: none;
  text-align: left;
}

.module-card__points li {
  position: relative;
  margin-bottom: 0.42rem;
  padding-left: 1.25rem;
  color: #2f2f2f;
  font-size: 0.94rem;
  line-height: 1.38;
}

.module-card__points li::before {
  content: "✓";
  position: absolute;
  left: 0;
  top: 0;
  color: #222;
  font-weight: 700;
}

.module-card__button {
  width: 100%;
  max-width: 180px;
  margin-top: auto;
}

.module-card__button-control {
  width: 100%;
}

@media (max-width: 991px) {
  .background {
    padding: 1.25rem 1rem 3rem;
  }

  .module-stage {
    padding: 1rem 1rem 2.5rem;
  }

  .module-stage__grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}

@media (max-width: 575px) {
  .module-page-title {
    font-size: 1.9rem;
  }

  .module-section__label {
    font-size: 1.05rem;
  }

  .module-card {
    min-height: auto;
    padding: 1.75rem 1.25rem 1.5rem;
  }

  .module-card__icon {
    width: 112px;
  }
}
</style>
